import React, { useContext } from 'react';
import { MicrocopyContext } from '/src/context/microcopy.context';
import ResultItem from '../components/resultItem';
import WDIResultsList from '../components/wdiResultsList';
import { getCopy } from '../../../helpers/copy';
import * as styles from './styles.module.scss';

const WDIRankingFilterList = ({
  results,
  totalCount,
  resultsPerPage,
  apiFilters,
  queryFilters,
  hideFilterOnLoad,
}) => {
  const microcopy = useContext(MicrocopyContext);

  return (
    <WDIResultsList
      queryFilters={queryFilters}
      itemRenderer={(props) => (
        <ResultItem
          {...props}
          isNew={props.new}
          hideCountry={queryFilters.countries}
        />
      )}
      resultsContainerClassName={styles.container}
      countLabelKey={getCopy('results.ranking.winners', microcopy)}
      results={results}
      totalCount={totalCount}
      resultsPerPage={resultsPerPage}
      visibleFilters={apiFilters}
      hideFilterOnLoad={hideFilterOnLoad}
      borderInHeader
      hideSort
      whiteBackground
    />
  );
};

export default WDIRankingFilterList;
